<template>
    <div>
        <Fieldset :legend="$t('searchHeader')" :toggleable="true">
            <div class="p-fluid p-mt-2 p-ml-3 p-mr-3 p-mb-2" @keyup.enter="saveData_Modal('search')">
                <div class="p-formgrid p-grid p-col">
                    <div class="p-field p-col-12 p-lg-3 p-mt-2">
                        <label for="course_name">{{ $t('itc_course_name') }}</label>
                        <InputText
                            id="course_name"
                            type="text"
                            v-model="course_name"
                            ref="TextBox_1_search"
                            @keyup.left="moveFocus($event, 'TextBox_3_search', 'Button')"
                            @keyup.right="moveFocus($event, 'TextBox_2_search', 'Button')"
                        />
                    </div>

                    <div class="p-field p-col-12 p-lg-3 p-mt-2">
                        <label for="course_level">{{ $t('itc_course_level') }}</label>
                        <Dropdown
                            v-model="courseLevelSelect"
                            :options="courseLevelOptions"
                            optionLabel="system_name"
                            :filter="true"
                            :placeholder="$t('placeholderSelectBox')"
                            :showClear="true"
                            :clearFilterDropdown="dropdownClearFilerValue"
                        >
                            <template #value="courseLevelOptions">
                                <div v-if="courseLevelOptions.value">
                                    <div>{{ courseLevelOptions.value.system_name }}</div>
                                </div>
                                <span v-else>
                                    {{ courseLevelOptions.placeholder }}
                                </span>
                            </template>
                            <template #option="courseLevelOptions">
                                <div>{{ courseLevelOptions.option.system_name }}</div>
                            </template>
                        </Dropdown>
                    </div>
                    <div class="p-field p-col">
                        <div class="p-formgrid p-grid p-jc-end p-mt-5">
                            <!-- Doe โหลด โทรศัพท์ -->
                            <Button
                                v-if="window.width <= 430"
                                @click="MobileClearSearchField()"
                                :label="$t('clearBtn')"
                                class="p-button-clear p-ml-3 p-mr-3"
                                ref="TextBox_2_search"
                                @keyup.left="moveFocus($event, 'TextBox_1_search', 'Input')"
                                @keyup.right="moveFocus($event, 'TextBox_3_search', 'Button')"
                            />
                            <Button
                                v-else
                                @click="clearSearchField()"
                                :label="$t('clearBtn')"
                                class="p-button-clear p-ml-3 p-mr-3"
                                ref="TextBox_2_search"
                                @keyup.left="moveFocus($event, 'TextBox_1_search', 'Input')"
                                @keyup.right="moveFocus($event, 'TextBox_3_search', 'Button')"
                            />
                            <!-- Doe โหลด โทรศัพท์ -->
                            <Button
                                @click="searchCourseInfo()"
                                :label="$t('searchBtn')"
                                class="p-button-info"
                                ref="TextBox_3_search"
                                @keyup.left="moveFocus($event, 'TextBox_2_search', 'Button')"
                                @keyup.right="moveFocus($event, 'TextBox_1_search', 'Input')"
                            />
                        </div>
                    </div>
                </div>
                <div class="p-formgrid p-grid p-col p-mt-1">
                    <text-footer :data="Data_text_Footer" :checkShow="text_Footer" :countItem="trainingCourse_Table.length.toLocaleString('en-US')" />
                </div>
            </div>
        </Fieldset>

        <div class="card p-fluid p-mt-2">
            <!-- Doe : เพิ่ม ลำดับ 1/4   sortField="index" :sortOrder="1" -->
            <DataTable
                :value="columns_disabled ? trainingCourse_Table : []"
                scrollHeight="500px"
                :paginator="true"
                :rows="10"
                dataKey="course_id"
                :sortOrder="1"
                sortField="index"
                ref="dt"
                :exportFilename="`ข้อมูลหลักสูตรการฝึกอบรม-${date}`"
                :rowHover="true"
                :selection.sync="selectedCourseInfo"
                :filters="filters"
                :loading="loading"
                class="dataTableSticky"
                paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                :rowsPerPageOptions="[10, 20, 50]"
                currentPageReportTemplate="แสดงผล {first} ถึง {last} จากทั้งหมด {totalRecords}"
            >
                <!-- Doe : เพิ่ม ลำดับ 1/4 จบ  sortField="index" :sortOrder="1" -->
                <template #header>
                    <div class="p-grid">
                        <div class="table-header p-col-12 p-lg-1" style="padding: 7px" id="Create" v-if="checkAdd_data != 'false'">
                            <Button @click="trainingCourseModal = true" :label="$t('addBtn')" class="p-button-success" />
                        </div>

                        <!-- Doe : PDF 1/3 -->
                        <div class="table-header" style="padding: 7px" id="EX">
                            <Button @click="exportCSV()" :label="$t('exportBtn')" style="background-color: green" />
                        </div>
                        <div class="table-header" style="padding: 7px" id="PDF">
                            <SplitButton
                                label="ส่งออก PDF"
                                :model="items"
                                class="p-button-raised p-button-danger"
                                style="background-color: #f33737"
                            ></SplitButton>
                        </div>
                        <!-- Doe : PDF 1/3 จบ -->

                        <!-- Doe PDF เลือกได้  1/5   -->
                        <div class="table-header" id="TABLE_EDIT" style="padding: 7px">
                            <Button
                                @click="EditPDF()"
                                icon="pi pi-cog"
                                :label="'ตั้งค่า'"
                                style="background-color: #0288d1; border: 1px solid #0288d1"
                            />
                        </div>

                        <div class="table-header" id="TABLE_EDIT" style="padding: 7px" v-if="selectedCourseInfo && selectedCourseInfo.length > 0">
                            <Button
                                @click="updateDates()"
                                icon="pi pi-cog"
                                :label="'ปรับปรุงข้อมูล'"
                                style="background-color: #fab12f; border: 1px solid #fab12f"
                            />
                        </div>

                        <!-- Doe PDF เลือกได้  1/5 จบ  -->

                        <div class="table-header p-col-12 p-lg-3" id="Search" style="margin-left: auto">
                            <!-- <span class="p-input-icon-left">
                <i class="pi pi-search" /><InputText
                  v-model="filters['global']"
                  :placeholder="$t('searchHeader')"
                />
              </span> -->

                            <!-- Doe ค้นหา  1/5 -->

                            <span class="p-input-icon-left" v-if="columns_disabled">
                                <i class="pi pi-search" />
                                <InputText v-model="filter" @input="search" :placeholder="$t('searchHeader')" ref="searchInput" />
                            </span>
                            <span class="p-input-icon-left" v-else>
                                <i class="pi pi-search" />
                                <InputText disabled v-model="filter" :placeholder="$t('searchHeader')" />
                            </span>

                            <!-- Doe ค้นหา  1/5 จบ-->
                        </div>
                    </div>
                </template>

                <Column :headerStyle="tableColSticky('8rem', 'center', 'sticky', 'top')">
                    <template #header>
                        <div v-if="columns_disabled">
                            <input
                                style="width: 20px; height: 20px"
                                type="checkbox"
                                :checked="selectedCourseInfo.length === trainingCourse_Table.length"
                                @change="onSelectAll($event.target.checked)"
                            />
                        </div>
                    </template>
                    <template #body="slotProps">
                        <div class="table_row" v-if="columns_disabled" style="text-align: center">
                            <input
                                style="width: 20px; height: 20px"
                                type="checkbox"
                                :checked="selectedCourseInfo.some((item) => item.course_id === slotProps.data.course_id)"
                                @change="onSelectRow(slotProps.data, $event.target.checked)"
                            />
                        </div>
                    </template>
                </Column>

                <template #empty>{{ $t('TableEmpty') }}</template>

                <!--Doe : เพิ่มลำดับ 2/4-->
                <div v-if="columns_index == true">
                    <Column field="index" :header="'ลำดับ'" :sortable="true" :headerStyle="tableColSticky('8rem', 'center', 'sticky', 'top')">
                        <template #body="dataTable">
                            <div class="table_row" v-if="columns_index == true">
                                {{ dataTable.data.index }}
                            </div>
                        </template>
                    </Column>
                </div>
                <div v-else>
                    <Column :headerStyle="tableColNone()"></Column>
                </div>
                <!--Doe : เพิ่มลำดับ 2/4 จบ-->

                <div v-if="columns_system_name == true">
                    <Column
                        field="system_name"
                        :header="$t('itc_course_level')"
                        :sortable="true"
                        :headerStyle="tableColSticky('15rem', '', 'sticky', 'top')"
                    >
                        <template #body="dataTable">
                            <div v-if="columns_system_name == true">
                                {{ dataTable.data.system_name }}
                            </div>
                        </template>
                    </Column>
                </div>
                <div v-else>
                    <Column :headerStyle="tableColNone()"></Column>
                </div>

                <div v-if="columns_course_name == true">
                    <Column
                        field="course_name"
                        :header="$t('itc_course_name')"
                        :sortable="true"
                        :headerStyle="tableColSticky('15rem', '', 'sticky', 'top')"
                    >
                        <template #body="dataTable">
                            <div v-if="columns_course_name == true">
                                {{ dataTable.data.course_name }}
                            </div>
                        </template>
                    </Column>
                </div>
                <div v-else>
                    <Column :headerStyle="tableColNone()"></Column>
                </div>

                <div v-if="columns_course_detail == true">
                    <Column field="course_detail" :header="$t('remark')" :sortable="true" :headerStyle="tableColSticky('15rem', '', 'sticky', 'top')">
                        <template #body="dataTable">
                            <div v-if="columns_course_detail == true">
                                {{ dataTable.data.course_detail }}
                            </div>
                        </template>
                    </Column>
                </div>
                <div v-else>
                    <Column :headerStyle="tableColNone()"></Column>
                </div>

                <div v-if="columns_data_course_training == true">
                    <Column
                        field="data_course_training"
                        header="รายละเอียด"
                        :sortable="true"
                        :headerStyle="tableColSticky('30rem', '', 'sticky', 'top')"
                    >
                        <template #body="dataTable">
                            <div v-if="columns_data_course_training == true">
                                <span v-html="dataTable.data.data_course_trainingHTML"></span>
                            </div>
                        </template>
                    </Column>
                </div>
                <div v-else>
                    <Column :headerStyle="tableColNone()"></Column>
                </div>

                <!-- <Column field="remark_name" :header="$t('remark')" :sortable="true" headerStyle="width: 15rem">
          <template #body="dataTable">
            
            <div v-if="dataTable.data.remark_name == ''">-</div>
            <div v-else>{{ dataTable.data.remark_name }}</div>
          </template>
        </Column> -->
                <!-- <Column field="start_date_name" :header="'วันที่เริ่มฝึกอบรม'" :sortable="true" headerStyle="width: 180px">
          <template #body="dataTable">
            {{ dataTable.data.start_date_name }}
          </template>
        </Column>
        <Column field="end_date_name" :header="'วันที่สิ้นสุดฝึกอบรม'" :sortable="true" headerStyle="width: 180px">
          <template #body="dataTable">
            {{ dataTable.data.end_date_name }}
          </template>
        </Column> -->

                <div v-if="columns_date_create == true">
                    <Column
                        field="date_create_ddmmyy"
                        :header="'วันที่สร้างข้อมูล'"
                        :sortable="true"
                        :headerStyle="tableColSticky('15rem', '', 'sticky', 'top')"
                    >
                        <template #body="dataTable">
                            <div v-if="columns_date_create == true">
                                {{ dataTable.data.date_create_ddmmyy }}
                            </div>
                        </template>
                    </Column>
                </div>
                <div v-else>
                    <Column :headerStyle="tableColNone()"></Column>
                </div>

                <div v-if="columns_date_update == true">
                    <Column
                        field="date_update_ddmmyy"
                        :header="'วันที่ปรับปรุงข้อมูล'"
                        :sortable="true"
                        :headerStyle="tableColSticky('15rem', '', 'sticky', 'top')"
                    >
                        <template #body="dataTable">
                            <div v-if="columns_date_update == true">
                                {{ dataTable.data.date_update_ddmmyy }}
                            </div>
                        </template>
                    </Column>
                </div>
                <div v-else>
                    <Column :headerStyle="tableColNone()"></Column>
                </div>

                <div
                    v-if="
                        columns_data_course_training ||
                        columns_index ||
                        columns_system_name ||
                        columns_course_name ||
                        columns_course_detail ||
                        columns_date_create ||
                        columns_date_update
                    "
                >
                    <Column
                        :header="$t('controlTable')"
                        :headerStyle="table_headerStyle"
                        :bodyStyle="table_bodyStyle"
                        v-if="checkEdit_data != 'false' || checkDelete_data != 'false'"
                    >
                        <template #body="dataTable">
                            <div class="p-formgrid col_manege" v-if="checkNotAdminPermission(dataTable.data.user_organize)">
                                <div :class="table_BOXmanege" v-if="checkEdit_data != 'false'">
                                    <Button
                                        @click="
                                            trainingCourseModal = true;
                                            editData(dataTable.data.course_id);
                                            temp = dataTable.data.course_id;
                                        "
                                        icon="pi pi-pencil"
                                        :label="table_editBTN"
                                        class="p-button-rounded p-button-warning"
                                    />
                                </div>
                                <div :class="table_BOXmanege" v-if="checkDelete_data != 'false'">
                                    <Button
                                        @click="
                                            // displayConfirmation = true;
                                            temp = dataTable.data.course_id;
                                            deleteAt = '';
                                            alertDisplay(temp, deleteAt);
                                        "
                                        icon="pi pi-trash"
                                        :label="table_deleteBTN"
                                        class="p-button-rounded p-button-danger"
                                    />
                                </div>
                            </div>
                            <div v-else>
                                {{ 'ไม่มีสิทธิ์จัดการข้อมูลนี้' }}
                            </div>
                        </template>
                    </Column>
                </div>
                <div v-else>
                    <Column headerStyle="width: 0"></Column>
                </div>
            </DataTable>
        </div>
        <!--  -->
        <!-- Manage data -->
        <Dialog
            :modal="true"
            :visible.sync="trainingCourseModal"
            :style="{ width: '80%' }"
            :contentStyle="{ 'overflow-y': 'scroll' }"
            :closable="loadingCreate ? false : true"
            :header="header"
        >
            <div class="confirmation-content" @keyup.enter="saveData_Modal('Modal_Main')">
                <!-- โหลดเพิ่มแก้ไข 1/8-->
                <div class="From_Loading" style="top: 38%" v-if="loadingCreate">
                    <ProgressSpinner style="width: 120px; height: 120px; color: red" strokeWidth="5" animationDuration="1s" />
                    <div class="waveTextAnimated">
                        <span>กำ</span>
                        <span>ลัง</span>
                        <span>บัน</span>
                        <span>ทึก</span>
                        <span>ข้อ</span>
                        <span>มูล</span>
                        <!-- กำลังบันทึกข้อมูล -->
                    </div>
                </div>
                <!-- โหลดเพิ่มแก้ไข 1/8 จบ-->
                <label>{{ $t('itc_modal_subtitle') }}</label>
                <div class="p-fluid p-mt-3">
                    <div class="p-grid p-col-12">
                        <div class="p-field p-col-12 p-lg-6 p-mt-2">
                            <label for="itc_course_level">{{ $t('itc_course_level') }} <span class="required-input">*</span></label>
                            <Dropdown
                                v-model="itc_course_level"
                                :options="courseLevelOptions"
                                optionLabel="system_name"
                                :filter="true"
                                :class="{
                                    'p-invalid': error_itc_course_level && !itc_course_level
                                }"
                                :placeholder="$t('placeholderSelectBox')"
                                :showClear="true"
                                :clearFilterDropdown="dropdownClearFilerValue"
                            >
                                <template #value="courseLevelOptions">
                                    <div v-if="courseLevelOptions.value">
                                        <div>{{ courseLevelOptions.value.system_name }}</div>
                                    </div>
                                    <span v-else>
                                        {{ courseLevelOptions.placeholder }}
                                    </span>
                                </template>
                                <template #option="courseLevelOptions">
                                    <div>{{ courseLevelOptions.option.system_name }}</div>
                                </template>
                            </Dropdown>
                            <small class="p-invalid" v-if="error_itc_course_level && !itc_course_level">{{ $t('itc_course_level_validate') }}</small>
                        </div>
                        <div class="p-field p-col-12 p-lg-6 p-mt-2">
                            <label for="itc_course_name">{{ $t('itc_course_name') }} <span class="required-input">*</span></label>
                            <InputText
                                id="itc_course_name"
                                type="text"
                                v-model="itc_course_name"
                                required="true"
                                :class="{
                                    'p-invalid': error_itc_course_name && !itc_course_name
                                }"
                                ref="TextBox_1"
                                @keyup.left="moveFocus($event, 'TextBox_5', 'Button')"
                                @keyup.right="moveFocus($event, 'TextBox_2', 'Input')"
                                @keyup.down="moveFocus($event, 'TextBox_2', 'Input')"
                            />
                            <small class="p-invalid" v-if="error_itc_course_name && !itc_course_name">{{ $t('itc_course_name_validate') }}</small>
                        </div>
                    </div>

                    <div class="p-formgrid p-grid p-col-12">
                        <div class="p-field p-col-12 p-lg-8 p-mt-2">
                            <label for="itc_remark">{{ $t('remark') }} <span class="required-input"> </span></label>
                            <InputText
                                id="itc_remark"
                                type="text"
                                v-model="itc_remark"
                                ref="TextBox_2"
                                @keyup.left="moveFocus($event, 'TextBox_1', 'Input')"
                                @keyup.right="moveFocus($event, 'TextBox_3', 'Button')"
                                @keyup.up="moveFocus($event, 'TextBox_1', 'Input')"
                                @keyup.down="moveFocus($event, 'TextBox_3', 'Button')"
                            />
                        </div>
                        <div class="p-field p-col-12 p-lg-2 p-mt-2">
                            <label for="date_create_form">วันที่สร้างข้อมูล <span class="required-input"> </span></label>
                            <InputText id="date_create_form" type="text" v-model="date_create_form" autofocus disabled />
                        </div>
                        <div class="p-field p-col-12 p-lg-2 p-mt-2">
                            <label for="date_update_form">{{ $t('imp_update_info_date') }}<span class="required-input"> </span></label>
                            <InputText id="date_update_form" type="text" v-model="date_update_form" autofocus disabled />
                        </div>
                    </div>

                    <div class="p-formgrid p-grid p-col-12">
                        <div class="p-field p-col-6 p-lg-3">
                            <Button
                                @click="showCourseDetailAdd = true"
                                icon="pi pi-plus"
                                :label="$t('addBtn')"
                                class="p-button-success"
                                ref="TextBox_3"
                                @keyup.left="moveFocus($event, 'TextBox_2', 'Input')"
                                @keyup.right="moveFocus($event, 'TextBox_4', 'Button')"
                                @keyup.up="moveFocus($event, 'TextBox_2', 'Input')"
                                @keyup.down="moveFocus($event, 'TextBox_4', 'Button')"
                            />
                        </div>
                    </div>
                    <div class="p-formgrid p-grid p-col-12">
                        <div class="p-field p-col-12 p-lg-12">
                            <DataTable
                                :value="courseDetail_table"
                                :scrollable="true"
                                scrollHeight="500px"
                                :paginator="true"
                                :rows="5"
                                dataKey="id"
                                :rowHover="true"
                                paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                                :rowsPerPageOptions="[5, 10, 20, 50]"
                                currentPageReportTemplate="แสดงผล {first} ถึง {last} จากทั้งหมด {totalRecords}"
                            >
                                <template #empty>{{ $t('TableEmpty') }}</template>
                                <Column field="gen" :header="$t('itc_generation')" :sortable="true" headerStyle="width: 10rem">
                                    <template #body="dataTable">
                                        {{ dataTable.data.gen }}
                                    </template>
                                </Column>
                                <Column field="start_date" :header="$t('itc_training_date')" :sortable="true" headerStyle="width: 15rem">
                                    <template #body="dataTable">
                                        เริ่ม {{ Format_Time(dataTable.data.start_date) }} <br />
                                        ถึง {{ Format_Time(dataTable.data.end_date) }}
                                    </template>
                                </Column>
                                <Column field="remark" :header="$t('remark')" :sortable="true" headerStyle="width: 15rem">
                                    <template #body="dataTable">
                                        {{ dataTable.data.remark }}
                                    </template>
                                </Column>
                                <Column :header="$t('controlTable')" headerStyle="width: 10rem">
                                    <template #body="dataTable">
                                        <div class="p-formgrid p-grid">
                                            <div class="p-field p-col-12">
                                                <Button
                                                    @click="
                                                        // displayConfirmation = true;
                                                        courseDetailDelete = dataTable.data;
                                                        deleteAt = 'detail-table';
                                                        alertDisplay(courseDetailDelete, deleteAt);
                                                    "
                                                    icon="pi pi-trash"
                                                    :label="$t('deleteBtn')"
                                                    class="p-button-rounded p-button-danger"
                                                />
                                            </div>
                                        </div>
                                    </template>
                                </Column>
                            </DataTable>
                        </div>
                    </div>
                </div>
            </div>
            <template #footer>
                <!-- โหลดเพิ่มแก้ไข 2/8-->
                <Button
                    v-if="selectedData != ''"
                    :label="$t('cancelBtn')"
                    icon="pi pi-times"
                    class="p-button-text"
                    :disabled="loadingCreate ? true : false"
                    @click="clearData()"
                    ref="TextBox_4"
                    @keyup.left="moveFocus($event, 'TextBox_3', 'Button')"
                    @keyup.right="moveFocus($event, 'TextBox_5', 'Button')"
                    @keyup.up="moveFocus($event, 'TextBox_3', 'Button')"
                />
                <Button
                    v-else
                    :label="$t('clearBtn')"
                    icon="pi pi-times"
                    class="p-button-text"
                    :disabled="loadingCreate ? true : false"
                    @click="clearData()"
                    ref="TextBox_4"
                    @keyup.left="moveFocus($event, 'TextBox_3', 'Button')"
                    @keyup.right="moveFocus($event, 'TextBox_5', 'Button')"
                    @keyup.up="moveFocus($event, 'TextBox_3', 'Button')"
                />
                <Button
                    :label="$t('saveBtn')"
                    icon="pi pi-check"
                    class="p-button-text"
                    :disabled="loadingCreate ? true : false"
                    @click="saveData()"
                    ref="TextBox_5"
                    @keyup.left="moveFocus($event, 'TextBox_4', 'Button')"
                    @keyup.right="moveFocus($event, 'TextBox_1', 'Input')"
                    @keyup.up="moveFocus($event, 'TextBox_3', 'Button')"
                />
                <!-- โหลดเพิ่มแก้ไข 2/8 จบ-->
            </template>
        </Dialog>

        <!-- Manage course detail data -->
        <Dialog :modal="true" :visible.sync="showCourseDetailAdd" :style="{ width: '600px' }" :header="headerDetail">
            <div class="confirmation-content" @keyup.enter="saveData_Modal('Modal_Course')">
                <label>{{ $t('itc_modal_subtitle_detail') }}</label>
                <div class="p-fluid p-mt-3">
                    <div class="p-grid p-col-12">
                        <div class="p-field p-col-12 p-lg-2 p-mt-2">
                            <label for="itc_generation">{{ $t('itc_generation') }} <span class="required-input">*</span></label>
                            <InputNumber
                                id="itc_generation"
                                v-model="itc_generation"
                                :min="0"
                                :class="{
                                    'p-invalid': error_itc_generation && !itc_generation
                                }"
                                ref="TextBox_1_Course"
                                @keyup.left="moveFocus($event, 'TextBox_4_Course', 'Button')"
                                @keyup.right="moveFocus($event, 'TextBox_2_Course', 'Input')"
                                @keyup.down="moveFocus($event, 'TextBox_2_Course', 'Input')"
                            />
                            <small class="p-invalid" v-if="error_itc_generation && !itc_generation">{{ $t('itc_generation_validate') }}</small>
                        </div>
                        <div class="p-field p-col-12 p-lg-5 p-mt-2">
                            <label for="itc_training_startdate">{{ $t('itc_training_startdate') }} <span class="required-input">*</span></label>
                            <Calendar
                                dateFormat="dd/mm/yy"
                                :maxDate="setTimeMaxMin(maxDate)"
                                :showButtonBar="true"
                                :monthNavigator="true"
                                :yearNavigator="true"
                                :yearRange="`2000:${setYearRange(date_yearRange, 1, 'plus')}`"
                                :locale="th"
                                id="itc_training_startdate"
                                v-model="itc_training_startdate"
                                :class="{
                                    'p-invalid': error_itc_training_startdate && !itc_training_startdate
                                }"
                            ></Calendar>
                            <small class="p-invalid" v-if="error_itc_training_startdate && !itc_training_startdate">{{
                                $t('itc_training_startdate_validate')
                            }}</small>
                        </div>
                        <div class="p-field p-col-12 p-lg-5 p-mt-2">
                            <label for="itc_training_enddate">{{ $t('itc_training_enddate') }} <span class="required-input">*</span></label>
                            <!-- yearRange="2000:2050" -->
                            <Calendar
                                dateFormat="dd/mm/yy"
                                :minDate="setTimeMaxMin(minDate)"
                                :showButtonBar="true"
                                :monthNavigator="true"
                                :yearNavigator="true"
                                :yearRange="`2000:${setYearRange(date_yearRange, 1, 'plus')}`"
                                :locale="th"
                                id="itc_training_enddate"
                                v-model="itc_training_enddate"
                                :class="{
                                    'p-invalid': error_itc_training_enddate && !itc_training_enddate
                                }"
                            ></Calendar>
                            <small class="p-invalid" v-if="error_itc_training_enddate && !itc_training_enddate">{{
                                $t('itc_training_enddate_validate')
                            }}</small>
                        </div>
                    </div>

                    <div class="p-formgrid p-grid p-col">
                        <div class="p-field p-col">
                            <label for="itc_detail_remark">{{ $t('remark') }}</label>
                            <InputText
                                id="itc_detail_remark"
                                type="text"
                                v-model="itc_detail_remark"
                                ref="TextBox_2_Course"
                                @keyup.left="moveFocus($event, 'TextBox_1_Course', 'InputNumber')"
                                @keyup.right="moveFocus($event, 'TextBox_3_Course', 'Button')"
                                @keyup.up="moveFocus($event, 'TextBox_1_Course', 'InputNumber')"
                                @keyup.down="moveFocus($event, 'TextBox_3_Course', 'Button')"
                            />
                        </div>
                    </div>
                </div>
            </div>
            <template #footer>
                <Button
                    :label="$t('clearBtn')"
                    icon="pi pi-times"
                    class="p-button-text"
                    @click="clearSubData()"
                    ref="TextBox_3_Course"
                    @keyup.left="moveFocus($event, 'TextBox_2_Course', 'Input')"
                    @keyup.right="moveFocus($event, 'TextBox_4_Course', 'Button')"
                    @keyup.up="moveFocus($event, 'TextBox_2_Course', 'Input')"
                />
                <Button
                    :label="$t('saveBtn')"
                    icon="pi pi-check"
                    class="p-button-text"
                    @click="saveDetailData()"
                    ref="TextBox_4_Course"
                    @keyup.left="moveFocus($event, 'TextBox_3_Course', 'Button')"
                    @keyup.right="moveFocus($event, 'TextBox_1_Course', 'InputNumber')"
                    @keyup.up="moveFocus($event, 'TextBox_2_Course', 'Input')"
                />
            </template>
        </Dialog>

        <Dialog :modal="true" :header="$t('ConfirmDelete')" :visible.sync="displayConfirmation" :style="{ width: '350px' }">
            <div class="confirmation-content p-mt-3">
                <i class="pi pi-exclamation-triangle p-mr-3 p-mt2" style="font-size: 2rem" />
                <span>{{ $t('ConfirmDeleteSub') }}</span>
            </div>
            <template #footer>
                <Button :label="$t('cancelBtn')" icon="pi pi-times" @click="displayConfirmation = false" class="p-button-text" />
                <Button :label="$t('confirmBtn')" icon="pi pi-check" @click="confirmDelete(temp)" class="p-button-text" autofocus />
            </template>
        </Dialog>

        <!-- Are you sure for close this modal -->
        <Dialog :modal="true" :header="$t('ConfirmCloseModal')" :visible.sync="displayConfirmationCloseModal" :style="{ width: '350px' }">
            <div class="confirmation-content p-mt-3">
                <span>{{ $t('ConfirmCloseModalSub') }}</span>
            </div>
            <template #footer>
                <Button :label="$t('cancelBtn')" icon="pi pi-times" @click="displayConfirmationCloseModal = false" class="p-button-text" />
                <Button :label="$t('confirmBtn')" icon="pi pi-check" @click="closeAllModal()" class="p-button-text" autofocus />
            </template>
        </Dialog>

        <!-- Doe PDF เลือกได้  -->
        <Dialog header="ตั้งค่า " :visible.sync="displayEditPDF" :style="{ width: '25rem' }" :contentStyle="{ 'overflow-y': 'visible' }">
            <label>ตั้งค่าการแสดงข้อมูลตารางและการส่งออกข้อมูล</label>
            <div style="margin: 2.5rem 1rem 0 1rem">
                <div class="p-formgrid p-grid">
                    <div class="p-field p-col-12">
                        <MultiSelect
                            v-model="columnsSelectorDialog"
                            :options="columns"
                            optionLabel="title"
                            :placeholder="$t('placeholderSelectBox')"
                            :filter="true"
                            class="multiselect-custom"
                        >
                            <template #value="slotProps">
                                <div class="item item-value" v-for="option of slotProps.value" :key="option.dataKey">
                                    <div>{{ option.title }}</div>
                                </div>
                                <template v-if="!slotProps.value || slotProps.value.length === 0">
                                    {{ $t('placeholderSelectBox') }}
                                </template>
                            </template>
                            <template #option="slotProps">
                                <div class="item">
                                    <div>{{ slotProps.option.title }}</div>
                                </div>
                            </template>
                        </MultiSelect>
                        <div style="margin-top: 1rem; display: flex; justify-content: flex-end">
                            <Button @click="ClearEditPDF()" class="p-button-clear" :label="'ล้างข้อมูล'" style="margin-right: 1rem" />
                            <Button @click="SelectAllEditPDF()" class="p-button-info" :label="'เลือกทั้งหมด'" />
                        </div>
                    </div>
                </div>
            </div>
            <template #footer>
                <div>
                    <Button @click="CloseEditPDF()" :label="'ยกเลิก'" icon="pi pi-times" class="p-button-text" />
                    <Button @click="SaveEditPDF()" :label="'บันทึก'" icon="pi pi-check" class="p-button-text" />
                </div>
            </template>
        </Dialog>
        <!-- Doe PDF เลือกได้ -->
    </div>
</template>

<script>
// Doe : PDF 2/3
// เพิ่ม pdf กับ font
// import { jsPDF } from "jspdf";
// import {font} from '../../../../public/assets/font/Sarabun-Regular-normal';
// Doe : PDF 2/3 จบ
import moment from 'moment';

import textFooter from '../../../mixins/textFooter_Search_html';

export default {
    name: 'initial-course',
    components: {
        textFooter
    },
    data() {
        return {
            searchTimeout: null,
            searchInputRef: null,
            dropdownClearFilerValue: 0,
            date: moment().locale('th').add(543, 'year').format('l'),
            date_yearRange: new Date(),
            // Doe ค้นหา  2/5
            filter: '',
            ms: false,
            cloneTable: [],
            // Doe ค้นหา  2/5 จบ

            // Doe โหลด โทรศัพท์
            // Doe width 1/4
            window: {
                width: 0,
                height: 0
            },

            checkRole: null,
            checkView_data: null,
            checkAdd_data: null,
            checkEdit_data: null,
            checkDelete_data: null,

            course_name: '',
            courseLevelOptions: [],
            courseLevelSelect: null,
            temp: null,
            displayConfirmation: false,
            filters: {},
            selectedCourseInfo: [],

            trainingCourse_Table: [],
            courseDetail_table: [],
            courseDetailDelete: {},
            deleteAt: '',
            selectedData: '',
            trainingCourseModal: false,
            showCourseDetailAdd: false,

            itc_course_name: '',
            itc_course_level: null,
            itc_remark: '',
            itc_generation: null,
            itc_training_startdate: '',
            itc_training_enddate: '',
            itc_detail_remark: '',
            error_itc_generation: false,
            error_itc_training_startdate: false,
            error_itc_training_enddate: false,

            minDate: null,
            maxDate: null,
            error_itc_course_name: false,
            error_itc_course_level: false,
            header: this.$i18n.t('itc_modal_title_add'),
            headerDetail: this.$i18n.t('itc_modal_title_add_detail'),

            check_duplicate: '',
            displayConfirmationCloseModal: false,
            tempFor_displayConfirmationCloseModal: '',

            date_create_form: '',
            date_update_form: '',

            loading: false,
            // โหลดเพิ่มแก้ไข 3/8
            loadingCreate: false,
            // โหลดเพิ่มแก้ไข 3/8 จบ

            //
            text_Footer: false,
            Clone_Data_text_Footer: [],
            Data_text_Footer: [
                {
                    DataName: 'ชื่อหลักสูตร',
                    textShow: ''
                },
                {
                    DataName: 'ระดับหลักสูตร',
                    textShow: ''
                }
            ],

            setDialogScroll: {},
            zoomLevel: 0,

            table_BOXmanege: window.innerWidth > 700 ? 'p-field p-col' : '',
            table_editBTN: window.innerWidth > 700 ? this.$i18n.t('editBtn') : '',
            table_deleteBTN: window.innerWidth > 700 ? this.$i18n.t('deleteBtn') : '',

            table_headerStyle: this.checkInnerWidth('15rem', 'Column'),
            table_bodyStyle: this.checkInnerWidth('15rem', 'Body'),

            // Doe PDF เลือกได้  2/5
            setPDF_Hor: 'l',
            setPosition_Hor: [802, 34, 802, 570],
            setPDF_Ver: 'p',
            setPosition_Ver: [570, 34, 575, 815],
            setPDF_Styles: 'grid',
            setnamePDF: 'ตารางข้อมูลหลักสูตรการฝึกอบรม',
            setPDF_fillColor: [95, 154, 250],
            setPDF_Margin: { left: 15, right: 15 },

            PDF_minCellWidthVer: 60,
            PDF_FontHeaderVer: 11,
            PDF_FontBodyVer: 8,

            PDF_BodySizeSelect: {},
            PDF_BodySize: {
                index: { cellWidth: 30 },
                data_course_training: { cellWidth: 200 },
                date_update_ddmmyy: { cellWidth: 60 }
            },

            PDF_minCellWidthHor: 100,
            PDF_FontHeaderHor: 15,
            PDF_FontBodyHor: 12,

            PDF_BodySizeHorSelect: {},
            PDF_BodySizeHor: {
                index: { cellWidth: 35 },
                course_name: { cellWidth: 100 },
                data_course_training: { cellWidth: 260, fontSize: 11 }
            },
            columns: [
                { title: 'ลำดับ', dataKey: 'index' },
                { title: 'ระดับหลักสูตร', dataKey: 'system_name' },
                { title: 'ชื่อหลักสูตร', dataKey: 'course_name' },
                { title: 'ข้อมูลเพิ่มเติม', dataKey: 'course_detail' },
                { title: 'รายละเอียด', dataKey: 'data_course_training' },
                { title: 'วันที่สร้างข้อมูล', dataKey: 'date_create_ddmmyy' },
                { title: 'วันที่ปรับปรุงข้อมูล', dataKey: 'date_update_ddmmyy' }
            ],

            columnsSelector: null,
            columnsSelectorDialog: null,

            displayEditPDF: false,

            columns_index: true,
            columns_system_name: true,
            columns_course_name: true,
            columns_course_detail: true,
            columns_data_course_training: true,
            columns_tambon_name: true,
            columns_amphur_name: true,
            columns_province_name: true,
            columns_event_lat: true,
            columns_event_lon: true,

            columns_date_create: true,
            columns_date_update: true,

            columns_disabled: true,
            // Doe PDF เลือกได้  2/5  จบ

            // Doe : PDF 3/3
            items: [
                {
                    label: ' แนวตั้ง',
                    command: () => {
                        this.$toast.add({ severity: 'success', summary: 'PDF', detail: 'แนวตั้ง', life: 3000 });

                        let columns = this.columnsSelector;

                        const Body_setCenter = ['index'];

                        const PintPDF = {
                            streak: this.setPDF_Ver,
                            setPosition: this.setPosition_Ver,
                            PDF_Styles: this.setPDF_Styles,
                            data: this.$refs.dt.processedData,
                            columns: columns,
                            columnsStyles: this.PDF_BodySizeSelect,
                            FileName: this.setnamePDF,
                            checkBody_Center: true,
                            Body_Center: Body_setCenter,
                            Col_FontSize: this.PDF_FontHeaderVer,
                            Body_FontSize: this.PDF_FontBodyVer,
                            minCell: this.PDF_minCellWidthVer,
                            marginPDF: this.setPDF_Margin,
                            fillColorPDF: this.setPDF_fillColor
                        };
                        this.printPDF(PintPDF);
                    }
                },

                {
                    label: 'แนวนอน',
                    command: () => {
                        this.$toast.add({ severity: 'success', summary: 'PDF', detail: 'แนวนอน', life: 3000 });

                        let columns = this.columnsSelector;

                        const Body_setCenter = ['index'];
                        const PintPDF = {
                            streak: this.setPDF_Hor,
                            setPosition: this.setPosition_Hor,
                            PDF_Styles: this.setPDF_Styles,
                            data: this.$refs.dt.processedData,
                            columns: columns,
                            columnsStyles: this.PDF_BodySizeHorSelect,
                            FileName: this.setnamePDF,
                            checkBody_Center: true,
                            Body_Center: Body_setCenter,
                            Col_FontSize: this.PDF_FontHeaderHor,
                            Body_FontSize: this.PDF_FontBodyHor,
                            minCell: this.PDF_minCellWidthHor,
                            marginPDF: this.setPDF_Margin,
                            fillColorPDF: this.setPDF_fillColor
                        };
                        this.printPDF(PintPDF);
                    }
                }
            ]
            // Doe : PDF 3/3 จบ
        };
    },
    watch: {
        async trainingCourseModal(val) {
            const today = new Date();
            const thaiDate = today.toLocaleDateString('th-TH', {
                year: 'numeric',
                month: 'long',
                day: 'numeric'
            });

            if (val == false) {
                if (
                    this.tempFor_displayConfirmationCloseModal == '' &&
                    this.selectedData == '' &&
                    this.itc_course_level != null &&
                    this.itc_course_name != ''
                ) {
                    // this.displayConfirmationCloseModal = true;
                    this.$fire({
                        title: 'ยืนยันการปิดหน้าต่างจัดการข้อมูล',
                        text: 'คุณต้องการออกจากการจัดการข้อมูลใช่หรือไม่ ?',

                        showCancelButton: true,
                        confirmButtonColor: '#3085d6',
                        cancelButtonColor: '#d33',
                        confirmButtonText: 'ตกลง',
                        cancelButtonText: 'ยกเลิก'
                    }).then((result) => {
                        if (result.value) {
                            this.trainingCourseModal = false;
                            this.clearData();
                        } else {
                            this.trainingCourseModal = true;
                        }
                    });
                } else {
                    this.clearData();
                    await this.axios
                        .post(`${this.$url_service}/initial/option`, {
                            body: { group: 'dg-06' }
                        })
                        .then((response) => {
                            (this.courseLevelOptions = response.data.data),
                                this.courseLevelOptions.splice(0, 0, {
                                    system_id: 'getall',
                                    system_name: this.$i18n.t('selectAll')
                                });
                        });
                }
            } else {
                if (this.temp === null) {
                    this.date_create_form = thaiDate;
                    this.date_update_form = thaiDate;
                }

                await this.axios
                    .post(`${this.$url_service}/initial/option`, {
                        body: { group: 'dg-06' }
                    })
                    .then((response) => {
                        this.courseLevelOptions = response.data.data;
                    });
            }
        },

        showCourseDetailAdd(val) {
            if (val == false) {
                this.clearSubData();
            } else {
                this.FocusRef_delay('TextBox_1_Course', 'InputNumber');
            }
        },

        displayConfirmationCloseModal(val) {
            if (val == true) {
                this.trainingCourseModal = true;
            }
        },

        itc_training_startdate(val) {
            if (val != '') {
                this.minDate = val;
                if (val == null) {
                    this.itc_training_startdate = '';
                }
            } else {
                this.itc_training_enddate = '';
                this.maxDate = null;
            }
        },

        itc_training_enddate(val) {
            if (val != '') {
                this.maxDate = val;
                if (val == null) {
                    this.itc_training_enddate = '';
                }
            }
        },
        // Doe PDF เลือกได้
        columnsSelector(val) {
            if (val.length == 0) {
                this.trainingCourse_Table = [];
            } else {
                this.trainingCourse_Table = this.cloneTable;
            }
        }

        // check_duplicate(val) {
        //   if (val == "duplicate") {
        //     // this.$toast.add({
        //     //   severity: "error",
        //     //   summary: "เพิ่มข้อมูลหลักสูตรการฝึกอบรมไม่สำเร็จ",
        //     //   detail: "มีข้อมูลหลักสูตรการฝึกอบรมนี้ในระบบแล้ว",
        //     //   life: 3000,
        //     // });
        //     this.$fire({
        //           type: "error",
        //           title:"เพิ่มข้อมูลหลักสูตรการฝึกอบรมไม่สำเร็จ",
        //           text: "มีข้อมูลหลักสูตรการฝึกอบรมนี้ในระบบแล้ว",
        //           timer: 3000,
        //           confirmButtonColor: '#28B463',
        //         });
        //   } else {
        //     // this.$toast.add({
        //     //   severity: "success",
        //     //   summary: "เพิ่มข้อมูลสำเร็จ",
        //     //   detail: "ข้อมูลหลักสูตรการฝึกอบรม",
        //     //   life: 3000,
        //     // });
        //     this.$fire({
        //           type: "success",
        //           title:"เพิ่มข้อมูลสำเร็จ",
        //           text: "ข้อมูลหลักสูตรการฝึกอบรม",
        //           timer: 3000,
        //           confirmButtonColor: '#28B463',
        //         });
        //   }
        // },
    },
    created() {
        // Doe โหลด โทรศัพท์
        // Doe width 2/4
        window.addEventListener('resize', this.handleResize);
        this.handleResize();

        if (this.window.width <= 430) {
            // console.log("this.window.width is",this.window.width)
            // console.log("00000")
            this.searchMenu();
        } else {
            // console.log("this.window.width is",this.window.width)
            // console.log("1111")
            this.ms = true;
            this.initialData();
        }
        // Doe โหลด โทรศัพท์

        // Doe PDF เลือกได้  4/5
        this.columnsSelector = this.columns;
        this.PDF_BodySizeSelect = this.PDF_BodySize;
        this.PDF_BodySizeHorSelect = this.PDF_BodySizeHor;
        // Doe PDF เลือกได้  4/5  จบ

        const decodedToken = this.decodeJWT(localStorage.getItem('token'));
        // this.initialData();
        this.checkRole = decodedToken.permission_id;

        this.checkView_data = decodedToken.view_data;
        this.checkAdd_data = decodedToken.add_data;
        this.checkEdit_data = decodedToken.edit_data;
        this.checkDelete_data = decodedToken.delete_data;

        // console.log(`checkRole = ${this.checkRole} `);
        // console.log(`checkView_data = ${this.checkView_data} `);
        // console.log(`checkAdd_data = ${this.checkAdd_data} `);
        // console.log(`checkEdit_data = ${this.checkEdit_data} `);
        // console.log(`checkDelete_data = ${this.checkDelete_data} `);

        this.Clone_Data_text_Footer = this.setCloneData(this.Data_text_Footer);
    },

    // Doe โหลด โทรศัพท์
    // Doe width 3/4
    destroyed() {
        window.removeEventListener('resize', this.handleResize);
    },
    // Doe โหลด โทรศัพท์

    mounted() {
        this.$nextTick(() => {
            this.searchInputRef = this.$refs.searchInput?.$el || this.$refs.searchInput;
        });
    },

    methods: {
        async updateDates() {
            try {
                this.loadingCreate = true;
                const userOrg = this.getUserOrganize();
                const userId = this.getUsername();

                // Format selected records
                const formattedRecords = this.selectedCourseInfo.map((item) => ({
                    course_id: item.course_id,
                    ...item
                }));

                // console.log('formattedRecords', formattedRecords);

                const response = await this.axios.post(`${this.$url_service}/initial/course?user=${userId}`, {
                    body: {
                        topic: 'edit-course_date_multiple',
                        selectedCourseInfo: formattedRecords,
                        userOrg: userOrg
                    }
                });

                // Check if response exists and has data
                if (response && response.data) {
                    if (response.data.success) {
                        this.loadingCreate = false;
                        this.tempFor_displayConfirmationCloseModal = 'add';
                        this.trainingCourseModal = false;

                        await this.$fire({
                            type: 'success',
                            title: 'ปรับปรุงข้อมูล',
                            text: `อัปเดตข้อมูลหลักสูตรการฝึกอบรมจำนวน ${response.data.updatedIds?.length || 0} รายการ`,
                            timer: 3000,
                            confirmButtonColor: '#28B463'
                        });

                        // Refresh data after successful update
                        await this.searchCourseInfo();
                    } else {
                        throw new Error(response.data.message || 'ไม่สามารถอัปเดตข้อมูลได้');
                    }
                }
            } catch (error) {
                this.loadingCreate = false;
                await this.$fire({
                    type: 'error',
                    title: 'เกิดข้อผิดพลาด',
                    text: error.response?.data?.message || error.message || 'ไม่สามารถอัปเดตข้อมูลได้',
                    timer: 3000,
                    confirmButtonColor: '#DC3545'
                });
            } finally {
                this.loadingCreate = false;
            }
        },

        onSelectAll(checked) {
            if (checked) {
                this.selectedCourseInfo = [...this.trainingCourse_Table];
            } else {
                this.selectedCourseInfo = [];
            }
            this.$emit('selectedCourseInfo', this.selectedCourseInfo);
            // console.log('selectedCourseInfo', this.selectedCourseInfo);
        },

        onSelectRow(row, checked) {
            if (checked) {
                if (!this.selectedCourseInfo.some((item) => item.course_id === row.course_id)) {
                    this.selectedCourseInfo.push(row);
                }
            } else {
                this.selectedCourseInfo = this.selectedCourseInfo.filter((item) => item.course_id !== row.course_id);
            }
            this.$emit('selectedCourseInfo', this.selectedCourseInfo);
            // console.log('selectedCourseInfo', this.selectedCourseInfo);
        },

        decodeJWT(token) {
            try {
                const payload = token.split('.')[1];
                // Replace Base64URL to Base64
                const base64 = payload.replace(/-/g, '+').replace(/_/g, '/');
                // Decode Base64
                const decodedPayload = atob(base64);
                // Handle UTF-8 encoding and return the parsed JSON object
                const jsonPayload = decodeURIComponent(
                    decodedPayload
                        .split('')
                        .map((c) => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
                        .join('')
                );
                return JSON.parse(jsonPayload);
            } catch (error) {
                console.error('Failed to decode JWT token:', error);
                return null;
            }
        },

        saveData_Modal(ModalName) {
            if (ModalName === 'search') {
                if (!this.isFocused('TextBox_2_search') && !this.isFocused('TextBox_3_search')) {
                    this.searchCourseInfo();
                }
            } else if (ModalName === 'Modal_Main') {
                if (!this.isFocused('TextBox_3') && !this.isFocused('TextBox_4') && !this.isFocused('TextBox_5')) {
                    this.saveData();
                }
            } else if (ModalName === 'Modal_Course') {
                if (!this.isFocused('TextBox_3_Course') && !this.isFocused('TextBox_4_Course')) {
                    this.saveDetailData();
                }
            }
        },
        exportCSV() {
            debugger;
            this.$refs.dt.exportCSV();
        },

        // Doe โหลด โทรศัพท์
        // Doe width 4/4
        handleResize() {
            this.window.width = window.innerWidth;
            this.window.height = window.innerHeight;

            this.table_BOXmanege = window.innerWidth > 700 ? 'p-field p-col' : '';
            this.table_editBTN = window.innerWidth > 700 ? this.$i18n.t('editBtn') : '';
            this.table_deleteBTN = window.innerWidth > 700 ? this.$i18n.t('deleteBtn') : '';
            if (window.innerWidth > 700) {
                this.table_headerStyle = this.checkInnerWidth('15rem', 'Column');
                this.table_bodyStyle = this.checkInnerWidth('15rem', 'Body');
            } else {
                this.table_headerStyle = this.checkInnerWidth('105px', 'Column');
                this.table_bodyStyle = this.checkInnerWidth('105px', 'Body');
            }

            const zoom = Math.round(window.devicePixelRatio * 100);
            this.zoomLevel = zoom;
            if (this.$refs.maintenEdit_calendar !== null && this.$refs.maintenEdit_calendar !== undefined) {
                const width = this.$refs.maintenEdit_calendar.offsetWidth;
                if (width > 226.66) {
                    this.setDialogScroll = { overflow: 'auto' };
                } else {
                    this.setDialogScroll = { overflow: 'visible' };
                }
            }
        },

        async searchMenu() {
            // console.log("79")
            await this.axios
                .post(`${this.$url_service}/initial/option`, {
                    body: { group: 'dg-06' }
                })
                .then((response) => {
                    (this.courseLevelOptions = response.data.data),
                        this.courseLevelOptions.splice(0, 0, {
                            system_id: 'getall',
                            system_name: this.$i18n.t('selectAll')
                        });
                });
        },

        // Doe โหลด โทรศัพท์

        // Doe ค้นหา  3/6
        search() {
            // Store reference to the input element
            if (event && event.target) {
                this.searchInputRef = event.target;
            }

            // Cancel any existing timeout
            if (this.searchTimeout) {
                clearTimeout(this.searchTimeout);
            }

            // Use debounce to delay processing
            this.searchTimeout = setTimeout(() => {
                if (this.filter != '' && this.trainingCourse_Table !== []) {
                    this.trainingCourse_Table = this.cloneTable.filter((item) => {
                        return (
                            (this.columns_course_name ? item.course_name.includes(this.filter) : '') ||
                            (this.columns_course_detail ? item.course_detail.includes(this.filter) : '') ||
                            (this.columns_data_course_training ? item.data_course_training.includes(this.filter) : '') ||
                            (this.columns_system_name ? item.system_name.includes(this.filter) : '') ||
                            (this.columns_date_create ? item.date_create_ddmmyy.includes(this.filter) : '') ||
                            (this.columns_date_update ? item.date_update_ddmmyy.includes(this.filter) : '')
                        );
                    });

                    for (let i = 0; i < this.trainingCourse_Table.length; i++) {
                        this.trainingCourse_Table[i]['index'] = i + 1;
                    }
                } else {
                    this.trainingCourse_Table = [...this.cloneTable];
                    for (let i = 0; i < this.trainingCourse_Table.length; i++) {
                        this.trainingCourse_Table[i]['index'] = i + 1;
                    }
                }

                // Restore focus to input element after rendering completes
                this.$nextTick(() => {
                    if (this.searchInputRef) {
                        this.searchInputRef.focus();

                        // Place cursor at the end of the text
                        const length = this.searchInputRef.value.length;
                        this.searchInputRef.setSelectionRange(length, length);
                    }
                });
            }, 300); // 300ms delay
        },
        // Doe ค้นหา  3/6 จบ

        async initialData() {
            this.ms = true;
            this.filter = '';
            this.cloneTable = [];
            this.loading = true;
            await this.axios
                .post(`${this.$url_service}/initial/course`, {
                    body: {
                        topic: 'get-table'
                        // userOrg: this.checkPermission() ? null : this.getUserOrganize(),
                    }
                })
                // Doe : เพิ่ม ลำดับ 3/4
                .then((response) => {
                    this.trainingCourse_Table = response.data.data;
                    // Doe ค้นหา  4/6
                    this.cloneTable = response.data.data;
                    // Doe ค้นหา  4/6
                    // console.log("this.trainingCourse_Table",this.trainingCourse_Table)

                    for (let i = 0; i < this.trainingCourse_Table.length; i++) {
                        this.trainingCourse_Table[i]['index'] = i + 1;
                    }

                    // Doe ช่องว่างใส่ ขีด
                    this.formatData(this.trainingCourse_Table);
                });
            // Doe : เพิ่ม ลำดับ 3/4 จบ

            if (this.columns_disabled == true) {
                this.trainingCourse_Table = this.cloneTable;
            } else {
                this.trainingCourse_Table = [];
            }

            await this.axios
                .post(`${this.$url_service}/initial/option`, {
                    body: { group: 'dg-06' }
                })
                .then((response) => {
                    (this.courseLevelOptions = response.data.data),
                        this.courseLevelOptions.splice(0, 0, {
                            system_id: 'getall',
                            system_name: this.$i18n.t('selectAll')
                        });
                });
            this.loading = false;
        },
        formatData(data) {
            for (let index = 0; index < data.length; index++) {
                if (data[index].system_name == null || data[index].system_name == 'null' || data[index].system_name == '') {
                    data[index].system_name = '-';
                }
                if (data[index].remark_name == null || data[index].remark_name == 'null' || data[index].remark_name == '') {
                    data[index].remark_name = '-';
                }
                if (data[index].course_detail == null || data[index].course_detail == 'null' || data[index].course_detail == '') {
                    data[index].course_detail = '-';
                }

                if (data[index].date_create_ddmmyy == null || data[index].date_create_ddmmyy == 'null' || data[index].date_create_ddmmyy == '') {
                    data[index].date_create_ddmmyy = '-';
                } else {
                    data[index].date_create_ddmmyy = this.changeDateToThai(this.checkDate(data[index].date_create_ddmmyy));
                }

                if (data[index].date_update_ddmmyy == null || data[index].date_update_ddmmyy == 'null' || data[index].date_update_ddmmyy == '') {
                    data[index].date_update_ddmmyy = '-';
                } else {
                    data[index].date_update_ddmmyy = this.changeDateToThai(this.checkDate(data[index].date_update_ddmmyy));
                }
            }
        },
        closeAllModal() {
            // console.log("Close and don`t save data");
            this.trainingCourseModal = false;
            this.displayConfirmationCloseModal = false;
            this.clearData();
        },

        async searchCourseInfo() {
            if (!this.checkToken()) {
                return;
            }

            // console.log('this.checkToken() = ', this.checkToken());

            this.ms = true;
            // this.filter='';
            this.cloneTable = [];
            this.loading = true;
            await this.axios
                .post(`${this.$url_service}/initial/course`, {
                    body: {
                        topic: 'search-table',
                        keyword: this.course_name,
                        level: this.courseLevelSelect
                        // userOrg: this.checkPermission() ? null : this.getUserOrganize(),
                    }
                })
                // Doe : เพิ่ม ลำดับ 4/4
                .then((response) => {
                    this.trainingCourse_Table = response.data.data;
                    // Doe ค้นหา  5/6
                    this.cloneTable = response.data.data;
                    // Doe ค้นหา  5/6

                    for (let i = 0; i < this.trainingCourse_Table.length; i++) {
                        this.trainingCourse_Table[i]['index'] = i + 1;
                    }

                    // Doe ช่องว่างใส่ ขีด
                    this.formatData(this.trainingCourse_Table);

                    // this.search()
                    this.setSearchText_Footer();
                });
            // Doe : เพิ่ม ลำดับ 4/4 จบ

            if (this.columns_disabled == true) {
                this.trainingCourse_Table = this.cloneTable;
            } else {
                this.trainingCourse_Table = [];
            }

            this.search();
            this.loading = false;
        },
        setSearchText_Footer() {
            this.text_Footer = false;
            this.Data_text_Footer = this.setCloneData(this.Clone_Data_text_Footer);
            if (this.course_name !== '' || this.courseLevelSelect !== null) {
                for (let index = 0; index < this.Data_text_Footer.length; index++) {
                    const element = this.Data_text_Footer[index];
                    if (element.DataName === 'ชื่อหลักสูตร' && this.course_name !== '') {
                        element.textShow = this.course_name;
                    }
                    if (element.DataName === 'ระดับหลักสูตร' && this.courseLevelSelect !== null) {
                        element.textShow = this.courseLevelSelect.system_name;
                    }
                }
                this.text_Footer = true;
            }
        },
        async confirmDelete() {
            if (!this.checkToken()) {
                return;
            }

            const userId = this.getUsername();

            // console.log('this.checkToken() = ', this.checkToken());

            if (this.deleteAt == 'detail-table') {
                this.courseDetail_table = this.courseDetail_table.filter((val) => val !== this.courseDetailDelete);
                this.displayConfirmation = false;
            } else {
                await this.axios
                    .post(`${this.$url_service}/initial/course?user=${userId}`, {
                        body: {
                            topic: 'delete-course',
                            id: this.temp
                        }
                    })
                    .then(() =>
                        // this.initialData()
                        this.searchCourseInfo()
                    );
                this.displayConfirmation = false;
                // this.$toast.add({
                //   severity: "success",
                //   summary: "ลบข้อมูลสำเร็จ",
                //   detail: "ข้อมูลหลักสูตรการฝึกอบรม",
                //   life: 3000,
                // });
                this.$fire({
                    type: 'success',
                    title: 'ลบข้อมูลสำเร็จ',
                    text: 'ข้อมูลหลักสูตรการฝึกอบรม',
                    timer: 3000,
                    confirmButtonColor: '#28B463'
                });
            }
        },

        async saveData() {
            if (!this.checkToken()) {
                return;
            }

            // console.log('this.checkToken() = ', this.checkToken());

            if (this.itc_course_name == '' || this.itc_course_level == null) {
                if (this.itc_course_name == '') {
                    this.error_itc_course_name = true;
                }
                if (this.itc_course_level == null) {
                    this.error_itc_course_level = true;
                }
            } else {
                if (this.selectedData == '') {
                    // โหลดเพิ่มแก้ไข 4/8
                    this.loadingCreate = true;
                    // โหลดเพิ่มแก้ไข 4/8 จบ

                    const userOrg = this.checkPermission() ? null : this.getUserOrganize(); //เช็คสิทธิ์
                    const userId = this.getUsername();
                    await this.axios
                        .post(`${this.$url_service}/initial/course?user=${userId}`, {
                            body: {
                                topic: 'add-course',
                                userOrg,
                                level: this.itc_course_level.system_id,
                                name: this.itc_course_name,
                                detail: this.itc_remark,
                                trainingtable: this.courseDetail_table
                            }
                        })
                        .then((response) => {
                            (this.check_duplicate = response.data.message),
                                // this.initialData();
                                this.searchCourseInfo();

                            // โหลดเพิ่มแก้ไข 5/8
                            this.loadingCreate = false;
                            // โหลดเพิ่มแก้ไข 5/8 จบ

                            // เพิ่ม เพิ่มข้อมูลให้แสดงรอบสอง พร้อมกับ เช็คข้อมูลซ้ำ
                            // console.log("this.check_duplicate ",this.check_duplicate)
                            if (this.check_duplicate == 'duplicate') {
                                this.$fire({
                                    type: 'error',
                                    title: 'เพิ่มข้อมูลพื้นฐานระบบไม่สำเร็จ',
                                    text: 'มีข้อมูลนี้ในระบบแล้ว',
                                    timer: 3000,
                                    confirmButtonColor: '#d33'
                                });
                            } else {
                                this.$fire({
                                    title: 'เพิ่มข้อมูลสำเร็จ',
                                    text: 'ข้อมูลหลักสูตรการฝึกอบรม',
                                    type: 'success',
                                    timer: 3000,
                                    confirmButtonColor: '#28B463'
                                });
                            }
                        });
                    this.tempFor_displayConfirmationCloseModal = 'add';
                    this.trainingCourseModal = false;
                } else {
                    // โหลดเพิ่มแก้ไข 6/8 จบ
                    this.loadingCreate = true;
                    // โหลดเพิ่มแก้ไข 6/8 จบ
                    const userId = this.getUsername();
                    await this.axios
                        .post(`${this.$url_service}/initial/course?user=${userId}`, {
                            body: {
                                topic: 'edit-course',
                                id: this.temp,
                                level: this.itc_course_level.system_id,
                                name: this.itc_course_name,
                                detail: this.itc_remark,
                                trainingtable: this.courseDetail_table
                            }
                        })
                        .then(() =>
                            // this.initialData()
                            this.searchCourseInfo()
                        );
                    // โหลดเพิ่มแก้ไข 7/8 จบ
                    this.loadingCreate = false;
                    // โหลดเพิ่มแก้ไข 7/8 จบ
                    // this.$toast.add({
                    //   severity: "success",
                    //   summary: "แก้ไขข้อมูลสำเร็จ",
                    //   detail: "ข้อมูลหลักสูตรการฝึกอบรม",
                    //   life: 3000,
                    // });
                    this.$fire({
                        type: 'success',
                        title: 'แก้ไขข้อมูลสำเร็จ',
                        text: 'ข้อมูลหลักสูตรการฝึกอบรม',
                        timer: 3000,
                        confirmButtonColor: '#28B463'
                    });
                    this.trainingCourseModal = false;
                }
            }
        },

        async editData(data) {
            if (!this.checkToken()) {
                return;
            }

            function toThaiDateFormat(dateString) {
                try {
                    // Split the date string by '/'
                    const [day, month, year] = dateString.split('/');

                    // Create a date object (months in JavaScript are 0-based, so subtract 1 from month)
                    const date = new Date(year, month - 1, day);

                    // Check if date is valid
                    if (isNaN(date.getTime())) {
                        return '-';
                    }

                    // Format options
                    const options = {
                        year: 'numeric',
                        month: 'long',
                        day: 'numeric'
                    };

                    // Convert to Thai date
                    return date.toLocaleDateString('th-TH', options);
                } catch (error) {
                    return '-';
                }
            }

            this.header = this.$i18n.t('itc_modal_title_edit');
            await this.axios
                .post(`${this.$url_service}/initial/course`, {
                    body: {
                        topic: 'showone-course',
                        id: data
                    }
                })
                .then((response) => {
                    (this.selectedData = response.data.data),
                        (this.itc_course_level = {
                            system_id: response.data.data.system_id,
                            system_name: response.data.data.system_name
                        }),
                        (this.itc_course_name = response.data.data.course_name),
                        (this.itc_remark = response.data.data.course_detail),
                        (this.courseDetail_table = JSON.parse(response.data.data.course_training_table));

                    this.date_create_form =
                        toThaiDateFormat(response.data.data.date_create_ddmmyy) == null
                            ? '-'
                            : toThaiDateFormat(response.data.data.date_create_ddmmyy);
                    this.date_update_form =
                        toThaiDateFormat(response.data.data.date_update_ddmmyy) == null
                            ? '-'
                            : toThaiDateFormat(response.data.data.date_update_ddmmyy);
                });
        },

        saveDetailData() {
            if (this.itc_training_startdate == '' || this.itc_training_enddate == '' || this.itc_generation == null || this.itc_generation == 0) {
                if (this.itc_training_startdate == '') {
                    this.error_itc_training_startdate = true;
                }
                if (this.itc_training_enddate == '') {
                    this.error_itc_training_enddate = true;
                }
                if (this.itc_generation == null || this.itc_generation == 0) {
                    this.error_itc_generation = true;
                }
            } else {
                const start = new Date(this.itc_training_startdate);
                const ye1 = new Intl.DateTimeFormat('en', { year: 'numeric' }).format(start);
                const mo1 = new Intl.DateTimeFormat('en', { month: '2-digit' }).format(start);
                const da1 = new Intl.DateTimeFormat('en', { day: '2-digit' }).format(start);
                this.itc_training_startdate = `${da1}/${mo1}/${ye1}`;

                const end = new Date(this.itc_training_enddate);
                const ye2 = new Intl.DateTimeFormat('en', { year: 'numeric' }).format(end);
                const mo2 = new Intl.DateTimeFormat('en', { month: '2-digit' }).format(end);
                const da2 = new Intl.DateTimeFormat('en', { day: '2-digit' }).format(end);
                this.itc_training_enddate = `${da2}/${mo2}/${ye2}`;

                this.courseDetail_table.push({
                    gen: this.itc_generation,
                    start_date: this.itc_training_startdate,
                    end_date: this.itc_training_enddate,
                    remark: this.itc_detail_remark
                });
                this.showCourseDetailAdd = false;
                this.clearSubData();
            }
        },

        clearData() {
            this.dropdownClearFilerValue += 1;
            //Edit data
            if (this.selectedData != '') {
                this.header = this.$i18n.t('itc_modal_title_add');
                this.temp = null;
                this.displayConfirmation = false;
                this.trainingCourseModal = false;
                this.selectedData = '';
                this.setDefault();
                //Add data
            } else {
                this.temp = null;
                this.displayConfirmation = false;
                this.setDefault();
            }
        },

        clearSubData() {
            this.dropdownClearFilerValue += 1;
            this.itc_generation = null;
            this.itc_training_startdate = '';
            this.itc_training_enddate = '';
            this.itc_detail_remark = '';
            this.minDate = null;
            this.maxDate = null;
            this.error_itc_generation = false;
            this.error_itc_training_startdate = false;
            this.error_itc_training_enddate = false;
        },

        setDefault() {
            this.tempFor_displayConfirmationCloseModal = '';
            this.itc_course_name = '';
            this.itc_course_level = null;
            this.itc_remark = '';
            this.error_itc_course_name = false;
            this.error_itc_course_level = false;
            this.courseDetail_table = [];

            this.date_create_form = '';
            this.date_update_form = '';
        },

        async clearSearchField() {
            this.course_name = '';
            this.courseLevelSelect = null;

            this.Data_text_Footer = this.setCloneData(this.Clone_Data_text_Footer);
            this.text_Footer = false;

            this.dropdownClearFilerValue += 1;
            // Doe ค้นหา
            this.filter = '';
            this.cloneTable = [];
            this.initialData();
        },

        // Doe โหลด โทรศัพท์
        async MobileClearSearchField() {
            // console.log("this.ms3333",this.ms)
            if (this.ms == true) {
                this.clearSearchField();
            } else {
                // console.log("25")
                this.course_name = '';
                this.courseLevelSelect = null;

                this.Data_text_Footer = this.setCloneData(this.Clone_Data_text_Footer);
                this.text_Footer = false;

                this.dropdownClearFilerValue += 1;
                this.filter = '';
                this.cloneTable = [];
            }
        },
        // Doe โหลด โทรศัพท์

        alertDisplay(temp, deleteAt) {
            this.$fire({
                title: 'ยืนยันการลบข้อมูล',
                text: 'คุณต้องการลบข้อมูลนี้ใช่หรือไม่ ?',

                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'ตกลง',
                cancelButtonText: 'ยกเลิก'
            }).then((result) => {
                // console.log(temp)
                if (result.value) {
                    // console.log(temp)
                    this.confirmDelete(temp, deleteAt);
                }
            });
        },
        // Doe PDF เลือกได้  5/5
        EditPDF() {
            this.displayEditPDF = true;
            this.columnsSelectorDialog = this.columnsSelector;
        },
        SaveEditPDF() {
            if (this.columnsSelectorDialog.length == 1) {
                this.PDF_minCellWidthVer = 120;
                this.PDF_FontHeaderVer = 13;
                this.PDF_FontBodyVer = 11;
                this.PDF_BodySizeSelect = {};

                this.PDF_minCellWidthHor = 120;
                this.PDF_FontHeaderHor = 15;
                this.PDF_FontBodyHor = 12;
                this.PDF_BodySizeHorSelect = {};
            } else if (this.columnsSelectorDialog.length <= 3) {
                this.PDF_minCellWidthVer = 70;
                this.PDF_FontHeaderVer = 13;
                this.PDF_FontBodyVer = 11;
                this.PDF_BodySizeSelect = {
                    index: { cellWidth: 35 }
                };

                this.PDF_minCellWidthHor = 100;
                this.PDF_FontHeaderHor = 15;
                this.PDF_FontBodyHor = 12;
                this.PDF_BodySizeHorSelect = {
                    index: { cellWidth: 35 }
                };
            } else {
                this.PDF_minCellWidthVer = 60;
                this.PDF_FontHeaderVer = 11;
                this.PDF_FontBodyVer = 8;
                this.PDF_BodySizeSelect = this.PDF_BodySize;

                this.PDF_minCellWidthHor = 100;
                this.PDF_FontHeaderHor = 15;
                this.PDF_FontBodyHor = 12;
                this.PDF_BodySizeHorSelect = this.PDF_BodySizeHor;
            }

            if (this.columnsSelectorDialog.length == 0) {
                this.columns_index = false;
                this.columns_system_name = false;
                this.columns_course_name = false;
                this.columns_course_detail = false;
                this.columns_data_course_training = false;

                this.columns_date_create = false;
                this.columns_date_update = false;

                this.columns_disabled = false;
            } else {
                this.columns_disabled = true;
                // console.log('this.columnsSelectorDialog =', this.columnsSelectorDialog);

                let getData = [];

                // ! จัดข้อมูล
                for (let index = 0; index < this.columnsSelectorDialog.length; index++) {
                    getData.push(this.columnsSelectorDialog[index].dataKey);
                }
                // console.log("getData",getData);

                // ! เช็คข้อมูล

                for (let index = 0; index < this.columnsSelectorDialog.length; index++) {
                    const element = this.columnsSelectorDialog[index].dataKey;

                    if (element == 'index') {
                        this.columns_index = true;
                    } else if (!getData.includes('index')) {
                        // console.log("getData.includes(index)",getData.includes("index"))
                        this.columns_index = false;
                    }

                    if (element == 'system_name') {
                        this.columns_system_name = true;
                    } else if (!getData.includes('system_name')) {
                        this.columns_system_name = false;
                    }

                    if (element == 'course_name') {
                        this.columns_course_name = true;
                    } else if (!getData.includes('course_name')) {
                        this.columns_course_name = false;
                    }

                    if (element == 'course_detail') {
                        this.columns_course_detail = true;
                    } else if (!getData.includes('course_detail')) {
                        this.columns_course_detail = false;
                    }

                    if (element == 'data_course_training') {
                        this.columns_data_course_training = true;
                    } else if (!getData.includes('data_course_training')) {
                        this.columns_data_course_training = false;
                    }

                    if (element == 'date_create_ddmmyy') {
                        this.columns_date_create = true;
                    } else if (!getData.includes('date_create_ddmmyy')) {
                        this.columns_date_create = false;
                    }

                    if (element == 'date_update_ddmmyy') {
                        this.columns_date_update = true;
                    } else if (!getData.includes('date_update_ddmmyy')) {
                        this.columns_date_update = false;
                    }
                }
            }

            this.columnsSelector = this.columnsSelectorDialog;
            this.displayEditPDF = false;
            this.filter = '';
        },
        CloseEditPDF() {
            this.displayEditPDF = false;
        },
        ClearEditPDF() {
            this.columnsSelectorDialog = [];
        },
        SelectAllEditPDF() {
            this.columnsSelectorDialog = this.columns;
        }
        // Doe PDF เลือกได้  5/5 จบ
    }
};
</script>

<style scoped>
.table_row {
    text-align: center;
}
@media screen and (min-width: 819px) and (max-width: 1200px) {
    #Search {
        width: 20rem;
    }
}
/* @media screen and (min-width: 538px){
      #Create{
      width: 146px;
    }
   
} */
#text_Foote {
    font-size: 1.2rem;
}
#Create {
    width: 149px;
}
#EX {
    width: 149px;
}
#PDF {
    width: 149px;
}
#TABLE_EDIT {
    width: 149px;
}
@media screen and (max-width: 818px) {
    #Search {
        width: 100%;
    }
}

@media screen and (max-width: 430px) {
    #Create {
        width: 50%;
    }
    #EX {
        width: 50%;
    }
    #PDF {
        width: 55%;
    }
    #TABLE_EDIT {
        width: 45%;
    }
}

.p-field {
    margin-bottom: 0rem;
}
</style>

<style>
@keyframes p-progress-spinner-color {
    100%,
    0% {
        stroke: #75e9f4;
    }
    40% {
        stroke: #0057e7;
    }
    66% {
        stroke: #75e9f4;
    }
    80%,
    90% {
        stroke: #0057e7;
    }
}
.p-datatable-thead {
    border: 2px solid #d6d6d6;
}

.p-datatable-tbody {
    border: 2px solid #d6d6d6;
}
</style>

<style scoped lang="scss">
:deep(.p-datatable-wrapper table) {
    border-left: 1px solid #d6d4d4;
    border-right: 1px solid #d6d4d4;
    border-collapse: separate;
    border-spacing: 0;
}
:deep(.p-datatable-scrollable-header-table) {
    background-color: #d6d4d4;
}
:deep(.p-datatable-wrapper) {
    max-height: 550px;
    overflow: auto;
}

.p-multiselect {
    min-width: 15rem;
}

.multiselect-custom {
    // Doe PDF เลือกได้
    width: 100%;
    .p-multiselect-label:not(.p-placeholder) {
        padding-top: 0.25rem;
        padding-bottom: 0.25rem;
    }

    .item {
        display: flex;
        align-items: center;
    }

    .item-value {
        padding-left: 10px;
        padding-right: 10px;
        border-radius: 3px;
        display: inline-flex;
        margin-right: 0.5rem;
        background-color: var(--primary-color);
        color: var(--primary-color-text);
    }
}
</style>
